import { CILabel, Input } from 'ccs-ui-components';
import { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IOccurrences } from '../../../../../models';
import classes from '../PatternRegistryForm.module.scss';

const Occurrences = (props: IOccurrences) => {
  const { t: translate } = useTranslation();
  const { formData, handleInputChange, isView } = props;
  const [showOthers, setShowOthers] = useState<boolean>(false);

  /**
   * useEffect to handle field interactions with each other
   */
  useEffect(() => {
    if (!formData.occurrences.isValid || parseInt(formData.occurrences.value, 10) < 2) {
      setShowOthers(false);
      formData.timeToLive.isValid = true;
      formData.uniqueId.isValid = true;
      formData.timeToLive.value = '';
      formData.uniqueId.value = '';
      formData.timeToLive.error = '';
      formData.uniqueId.error = '';
    } else {
      setShowOthers(true);
    }
  }, [formData]);

  return (
    <>
      <div className={classes['occurrences-form-header']}>
        <div className={classes['occurrences-header-title']}>{translate('pattern_registry_form.occurrences_form_title')}</div>
        <div className={classes['occurrences-header-subtitle']}>
          {translate('pattern_registry_form.occurrences_form_sub_title')}
        </div>
      </div>
      <Row>
        <Col sm={3} className={classes['pr-form-grp-col-flex']}>
          <Form.Group
            className={`${classes['form-grp']} ${classes['pr-form-grp-flex']}`}
          >
            <CILabel className={`${classes['form-label']} ${classes['pr-form-label-row']}`} id="occurrences" isMandatory labelText={translate('pattern_registry_form.lbl_occurrences_name')} infoIconText={translate('pattern_registry_form.occurences_info_bubble')} />
            <div className={classes['pr-first-div']}>
              <Input
                type="text"
                placeholder=""
                label=""
                name="occurrences"
                id="occurrences"
                value={formData.occurrences.value}
                onChange={handleInputChange}
                error={!formData.occurrences.isValid}
                data-testid="pr-occurrence-input"
                className={classes['cp-pr-fixed-width-input']}
                disabled={isView}
              />
              <div className={classes['cp-pr-error-container']}>
                {!formData.occurrences.isValid
                  && formData.occurrences.isTouched && (
                    <h6 className={classes['cp-pr-error']} data-testid="pattern-occurrence-error-text">
                      {formData.occurrences.error}
                    </h6>
                  )}
              </div>
            </div>
          </Form.Group>
        </Col>
        <Col sm={9}>
          <Row className={classes['cp-pr-left-padding']}>
            <Col sm={6}>
              <Form.Group
                className={`${classes['form-grp']} ${classes['pr-form-grp-flex']}`}
              >
                <CILabel className={`${classes['form-label']} ${classes['pr-form-label-row']} ${showOthers ? '' : classes['pr-div-hidden']}`} id="timeToLive" isMandatory labelText={translate('pattern_registry_form.lbl_Time_to_live_name')} infoIconText={translate('pattern_registry_form.time_to_live_info_bubble')} />
                <div className={`${classes['pr-first-div']} ${showOthers ? '' : classes['pr-div-hidden']}`}>
                  <Input
                    id="timeToLive"
                    type="text"
                    placeholder={String(translate('pattern_registry_form.plchd_time_to_live'))}
                    label=""
                    name="timeToLive"
                    value={formData.timeToLive.value}
                    onChange={handleInputChange}
                    error={!formData.timeToLive.isValid}
                    className={classes['cp-pr-fixed-width-input']}
                    disabled={isView}
                    data-testid="pr-ttl-input"
                  />
                  <div className={classes['cp-pr-error-container']}>
                    {!formData.timeToLive.isValid
                      && formData.timeToLive.isTouched && (
                        <h6 className={classes['cp-pr-error']} data-testid="pattern-ttl-error-text">
                          {formData.timeToLive.error}
                        </h6>
                      )}
                  </div>
                </div>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group
                className={`${classes['form-grp']} ${classes['pr-form-grp-flex']}`}
              >
                <CILabel className={`${classes['form-label']} ${classes['pr-form-label-row']} ${showOthers ? '' : classes['pr-div-hidden']}`} id="uniqueId" isMandatory labelText={translate('pattern_registry_form.lbl_unique_id_name')} infoIconText={translate('pattern_registry_form.unique_info_bubble')} />
                <div className={`${classes['pr-first-div']} ${showOthers ? '' : classes['pr-div-hidden']}`}>
                  <Input
                    type="text"
                    placeholder={String(translate('pattern_registry_form.plchd_unique_id'))}
                    label=""
                    id="uniqueId"
                    name="uniqueId"
                    value={formData.uniqueId.value}
                    onChange={handleInputChange}
                    error={!formData.uniqueId.isValid}
                    disabled={isView}
                    data-testid="pr-uniqueId-input"
                  />
                  <div className={classes['cp-pr-error-container']}>
                    {!formData.uniqueId.isValid
                      && formData.uniqueId.isTouched && (
                        <h6 className={classes['cp-pr-error']} data-testid="pattern-uniqueId-error-text">
                          {formData.uniqueId.error}
                        </h6>
                      )}
                  </div>
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Occurrences;
